import {DxSessionValidationStrategy} from "./dx-session-validation-strategy";
import {DxLogger} from "../../../../dx-core/services/dx-logger.service";
import {DxUserSession} from "../../../domain/user/dx-user-session";
import {Injectable} from "@angular/core";

@Injectable()
export class DxRefreshTokenValidationStrategy implements DxSessionValidationStrategy {

  constructor(private _logger: DxLogger) { }

  public validateSession(session: DxUserSession): boolean {
    // Сессия считается не валидной если:
    // 1. Сессии нет :) Первый заход в систему или был логаут.
    if (!session) return false;
    if (!session.refreshTokenExpTime) return false;

    // Если протух рефреш-токен. То есть если основной токен протух, а рефреш-токен еще нет,
    // то сессия считается валидной, но ее нужно обновить.
    this._logger.debug('Refresh token exp. time: ' + new Date(session.refreshTokenExpTime * 1000));
    const currentTime: number = Math.ceil(new Date().getTime() / 1000);
    if (session.refreshTokenExpTime && (currentTime > session.refreshTokenExpTime)) {
      this._logger.debug('Refresh token expired. Session closing.');
      return false;
    }
    return true;
  }
}
